import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import moment from 'moment';
import { Subscription, timer } from 'rxjs';
import { DataMonitoringService } from './../service/data-monitoring.service';
import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { Region } from 'src/app/model/region.model';
import { School } from 'src/app/model/school.model';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { DataMonitoringReportEnrollmentResult, studentsDataView } from '../model/data-monitoring-report-enrollment-result.model';
import { environment } from 'src/environments/environment';
import { UtilityService } from '../../../service/utility.service';
import { ApiExportsService } from 'src/app/service/api-exports.service';
import { UrlProviderService } from 'src/app/service/urlprovider.service';
import { RegionDropdownComponent } from '../../common-components/region/region-dropdown/region-dropdown.component';
import { CountyDropdownComponent } from '../../common-components/county/county-dropdown/county-dropdown.component';
import { DistrictDropdownComponent } from '../../common-components/district/district-dropdown/district-dropdown.component';
import { DtMonService } from '../service/dtmon.service';
import { SearchStudentResponseDataView } from 'src/app/model/reports/exportsModels';
import { SchoolDropdownComponent } from '../../common-components/school/school-dropdown/school-dropdown.component';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ThemePalette } from '@angular/material/core';

@Component({
    selector: 'app-data-monitoring-enrollments-divided',
    templateUrl: './data-monitoring-enrollments-divided.component.html',
    styleUrls: ['./data-monitoring-enrollments-divided.component.scss']
})
export class DataMonitoringEnrollmentsDividedComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    @ViewChild('appRegionCode') appRegionCode!: RegionDropdownComponent;
    @ViewChild('appCountyCode') appCountyCode!: CountyDropdownComponent;
    @ViewChild('appDistrictCode') appDistrictCode!: DistrictDropdownComponent;
    @ViewChild('appSchools') appSchools!: SchoolDropdownComponent;
    @ViewChild('searchResults', { read: ElementRef }) table?: ElementRef<HTMLElement>;
    @Input() searchParm: any = [{}];
    public data: { sIds: number[]; performancePeriod: string; mpoNumber: number; fileNameLabel: string };
    isLoadingResults: boolean = false;
    isExporting: boolean = false;

    progressCurrentValue: number = 10;
    progressValue: number = 10;
    progressMax: number = 200;
    progressSpinnerMax: number = 100;
    progressColor: ThemePalette = 'accent';
    progressType: ProgressSpinnerMode = 'determinate';
    progressSpeed: number = 50;

    progressSubscription: Subscription;
    progressInterval: number = 500;
    lstStudentsResponseDataView: studentsDataView[] = [];

    strExportFileName = 'R_Enrolled_and_Missing_SSID';
    fileNameLabel: string = '';
    bCheckedStyling: boolean = true;
    strExportName: string = 'R_Enrolled_and_Missing_SSID';

    settings: any = {
        '/data-monitoring-reports/r-enrolled-missing-ssid': {
            TITLE: 'R Enrolled and Missing SSID',
            EXPORTFILENAME: 'R_Enrolled_and_Missing_SSID',
            API: undefined,
            SCHOOL_YEAR: true,
            PERFORMANCE_PERIOD: false,
            HELP_TEXT_ID: 'DataMonitoring_REnrolledMissingSSID_Overview',
            COLUMN_HEADERS: ['Region', 'School Year', 'District', 'School', 'MSD Number', 'SSID', 'Name', 'DOB', 'Grade', 'Enroll Type', 'Enrollment Date'],
            COLUMN_WIDTHS: [28, 35, 100, 100, 50, 50, 75, 25, 25, 25, 25],
            COLUMNS: [
                'SCHOOL.REGIONS.CODE',
                'SCHOOL_ENROLLMENT_DETAILS[0].SCHOOL_YEAR',
                'SCHOOL.SCHOOL_DISTRICT.DISTRICTS',
                'SCHOOL.NAME',
                'MSD_NUMBER',
                'SSID',
                'PERSON.LAST_NAME',
                'DOB',
                'SCHOOL_ENROLLMENT_DETAILS[0].GRADE',
                'SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE',
                'SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE'
            ]
        }
    };
    currentSetting: any;

    // Search variables
    selectedSchoolYear: string = '';
    initialSchoolYear: string = '';
    currentSchoolYear: string = '';
    selectedSchool: string = '';
    selectedPerformancePeriod: string = '';
    initialPerformancePeriod: string = '';
    currentPerformancePeriod: string = '';
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenSchools: School[] = [];
    chosenSchoolYear: string = '';

    startingSchoolYearDate: Date;

    // Component variables
    resetField: boolean = false;

    // Table display
    regionColumns: string[] = ['CODE', 'NAME', 'COUNT'];
    countyColumns: string[] = ['CODE', 'NAME', 'COUNT'];
    schoolDistrictColumns: string[] = ['CODE', 'NAME', 'COUNT'];
    schoolColumns: string[] = ['CDSCODE', 'NAME', 'COUNT'];
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    // Tab labels
    regionLabel: string = '';
    countyLabel: string = '';
    schoolDistrictLabel: string = '';
    schoolLabel: string = '';
    searchResultLabel: string = '';
    selectedIndex: number = 0;

    // Table results
    regionDataSource!: MatTableDataSource<any>;
    countyDataSource!: MatTableDataSource<any>;
    schoolDistrictDataSource!: MatTableDataSource<any>;
    schoolDataSource!: MatTableDataSource<any>;
    lstSearchStudentResponseDataView: SearchStudentResponseDataView[] = [];
    searchResultDataSource!: MatTableDataSource<DataMonitoringReportEnrollmentResult>;

    // Results
    results: DataMonitoringReportEnrollmentResult[] = [];
    regionFilter: string = '';
    countyFilter: string = '';
    schoolDistrictFilter: string = '';
    schoolFilter: string = '';
    searchResultFilter: string = '';
    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    constructor(
        private dataMonitoringService: DataMonitoringService,
        public dtMonService: DtMonService,
        router: Router,
        private dialog: MatDialog,
        //public routeGuardService: RouteGuardService,
        private utilityService: UtilityService,
        private apiMsinExportsService: ApiExportsService,
        private urlProvider: UrlProviderService
    ) {
        this.connectAPIs(dataMonitoringService);
        this.selectSettings(router.url);
        this.setStartingSchoolYearDate();
    }

    connectAPIs(dataMonitoringService: DataMonitoringService) {
        this.settings['/data-monitoring-reports/r-enrolled-missing-ssid'].API = function (payload: any) {
            return dataMonitoringService.getREnrolledMissingSsid(payload);
        };
    }

    selectSettings(url: string) {
        this.currentSetting = this.settings[url];
    }

    setStartingSchoolYearDate() {
        // Set the cut-off day to go to next school year (the week after the 3rd Friday in Sept)
        let mDate = moment({ month: 8, day: 1 }); // month is 0 based

        // By default we will need to add two weeks to the first friday
        let nWeeks = 2;
        let month = mDate.month();

        // Get first Friday of the first week of the month
        mDate = mDate.date(1).day(5);

        // Check if first Friday is in the given month
        //  it may have gone to the previous month
        if (mDate.month() != month) {
            nWeeks++;
        }

        this.startingSchoolYearDate = mDate.add(nWeeks, 'weeks').add(3, 'days').toDate();
    }

    ngOnInit(): void {}

    search() {
        if (this.checkValid()) {
            this.isLoading = true;
            this.msg = {};
            this.regionFilter = '';
            this.countyFilter = '';
            this.schoolDistrictFilter = '';
            this.schoolFilter = '';
            this.searchResultFilter = '';

            this.currentSetting.API(this.generatePayload()).subscribe({
                next: (res: any) => {
                    console.log('API returned:');
                    console.log(res);
                    if (res.students) {
                        this.results = res.students.sort((n1: DataMonitoringReportEnrollmentResult, n2: DataMonitoringReportEnrollmentResult) =>
                            n1.PERSON!.LAST_NAME! > n2.PERSON!.LAST_NAME! ? 1 : -1
                        );

                        // Updates the Tables to be displayed w/ this.results
                        this.updateDataSource();
                    } else if (res.msg) {
                        this.results = [];
                        this.msg = res.msg;
                    } else {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving ' + this.currentSetting.TITLE + '.' };
                    }
                },
                error: (err: any) => {
                    this.results = [];
                    this.msg = { SUCCESS: false, MSG: 'Error retrieving ' + this.currentSetting.TITLE + '.' };
                },
                complete: () => {
                    // Display current performance period
                    this.currentSchoolYear = this.selectedSchoolYear;
                    this.currentPerformancePeriod = this.selectedPerformancePeriod;

                    // Display results
                    this.isLoading = false;

                    // Set to first tab
                    this.selectedIndex = 0;
                }
            });
        }
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.toNumberArray(this.chosenRegions);
        payload.chosenCounties = this.toNumberArray(this.chosenCounties);
        payload.chosenSchoolDistricts = this.toNumberArray(this.chosenSchoolDistricts);
        payload.chosenSchools = this.toNumberArray(this.chosenSchools);
        payload.schoolYear = this.selectedSchoolYear;
        payload.performancePeriod = this.selectedPerformancePeriod;

        return payload;
    }

    updateDataSource() {
        setTimeout(() => {
            this.updateRegionDataSource();
            this.updateCountyDataSource();
            this.updateSchoolDistrictDataSource();
            this.updateSchoolDataSource();
            this.updateResultDataSource();
        });
    }

    updateRegionDataSource() {
        let regions: any = {};
        let data: any[] = [];

        // Build Region
        this.results.forEach((result) => {
            if (!this.getPropertyPipe.transform(regions, result.SCHOOL.REGIONS.ID!.toString())) {
                regions[result.SCHOOL.REGIONS.ID!] = {
                    CODE: result.SCHOOL.REGIONS.CODE,
                    NAME: result.SCHOOL.REGIONS.NAME,
                    COUNT: 1
                };
            } else {
                regions[result.SCHOOL.REGIONS.ID!].COUNT++;
            }
        });

        let properties = Object.keys(regions);

        properties.forEach((property) => {
            data.push(regions[property]);
        });

        // Data
        this.regionDataSource = new MatTableDataSource<DataMonitoringReportEnrollmentResult>();
        this.regionDataSource.data = data;

        // Paginator
        //this.regionDataSource.paginator = this.paginators.toArray()[0];

        // Sort
        this.regionDataSource.sort = this.sorts.toArray()[0];
        const defaultSort: Sort = { active: 'CODE', direction: 'asc' };
        this.regionDataSource.sort.active = defaultSort.active;
        this.regionDataSource.sort.direction = defaultSort.direction;
        this.regionDataSource.sort.sortChange.emit(defaultSort);
        this.regionDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

        // Label Update
        this.regionLabel = data.length + ' Region(s)';
    }

    updateCountyDataSource() {
        let counties: any = {};
        let data: any[] = [];

        // Build Region
        this.results.forEach((result) => {
            if (!this.getPropertyPipe.transform(counties, result.SCHOOL.COUNTy.ID!.toString())) {
                counties[result.SCHOOL.COUNTy.ID!] = {
                    CODE: result.SCHOOL.COUNTy.COUNTY_CODE,
                    NAME: result.SCHOOL.COUNTy.COUNTY_NAME,
                    COUNT: 1
                };
            } else {
                counties[result.SCHOOL.COUNTy.ID!].COUNT++;
            }
        });

        let properties = Object.keys(counties);

        properties.forEach((property) => {
            data.push(counties[property]);
        });

        // Data
        this.countyDataSource = new MatTableDataSource<DataMonitoringReportEnrollmentResult>();
        this.countyDataSource.data = data;

        // Paginator
        //this.countyDataSource.paginator = this.paginators.toArray()[1];

        // Sort
        this.countyDataSource.sort = this.sorts.toArray()[1];
        const defaultSort: Sort = { active: 'CODE', direction: 'asc' };
        this.countyDataSource.sort.active = defaultSort.active;
        this.countyDataSource.sort.direction = defaultSort.direction;
        this.countyDataSource.sort.sortChange.emit(defaultSort);
        this.countyDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

        // Label Update
        this.countyLabel = data.length + ' County(s)';
    }

    updateSchoolDistrictDataSource() {
        let schoolDistricts: any = {};
        let data: any[] = [];

        // Build Region
        this.results.forEach((result) => {
            if (!this.getPropertyPipe.transform(schoolDistricts, result.SCHOOL.SCHOOL_DISTRICT.ID!.toString())) {
                schoolDistricts[result.SCHOOL.SCHOOL_DISTRICT.ID!] = {
                    CODE: result.SCHOOL.SCHOOL_DISTRICT.CODE,
                    NAME: result.SCHOOL.SCHOOL_DISTRICT.DISTRICTS,
                    COUNT: 1
                };
            } else {
                schoolDistricts[result.SCHOOL.SCHOOL_DISTRICT.ID!].COUNT++;
            }
        });

        let properties = Object.keys(schoolDistricts);

        properties.forEach((property) => {
            data.push(schoolDistricts[property]);
        });

        // Data
        this.schoolDistrictDataSource = new MatTableDataSource<DataMonitoringReportEnrollmentResult>();
        this.schoolDistrictDataSource.data = data;

        // Paginator
        //this.schoolDistrictDataSource.paginator = this.paginators.toArray()[2];

        // Sort
        this.schoolDistrictDataSource.sort = this.sorts.toArray()[2];
        const defaultSort: Sort = { active: 'CODE', direction: 'asc' };
        this.schoolDistrictDataSource.sort.active = defaultSort.active;
        this.schoolDistrictDataSource.sort.direction = defaultSort.direction;
        this.schoolDistrictDataSource.sort.sortChange.emit(defaultSort);
        this.schoolDistrictDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

        // Label Update
        this.schoolDistrictLabel = data.length + ' School District(s)';
    }

    updateSchoolDataSource() {
        let schools: any = {};
        let data: any[] = [];

        // Build Region
        this.results.forEach((result) => {
            if (!this.getPropertyPipe.transform(schools, result.SCHOOL.ID!.toString())) {
                schools[result.SCHOOL.ID!] = {
                    CDSCODE: result.SCHOOL.cdscODE,
                    NAME: result.SCHOOL.NAME,
                    COUNT: 1
                };
            } else {
                schools[result.SCHOOL.ID!].COUNT++;
            }
        });

        let properties = Object.keys(schools);

        properties.forEach((property) => {
            data.push(schools[property]);
        });

        // Data
        this.schoolDataSource = new MatTableDataSource<DataMonitoringReportEnrollmentResult>();
        this.schoolDataSource.data = data;

        // Paginator
        //this.schoolDataSource.paginator = this.paginators.toArray()[3];

        // Sort
        this.schoolDataSource.sort = this.sorts.toArray()[3];
        const defaultSort: Sort = { active: 'NAME', direction: 'asc' };
        this.schoolDataSource.sort.active = defaultSort.active;
        this.schoolDataSource.sort.direction = defaultSort.direction;
        this.schoolDataSource.sort.sortChange.emit(defaultSort);
        this.schoolDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

        // Label Update
        this.schoolLabel = data.length + ' School(s)';
    }

    updateResultDataSource() {
        // Display Columns
        this.displayedColumns = this.currentSetting.COLUMNS;

        // Data
        this.searchResultDataSource = new MatTableDataSource<DataMonitoringReportEnrollmentResult>();
        this.searchResultDataSource.data = this.results;

        // Paginator
        this.searchResultDataSource.paginator = this.paginators.toArray()[0];

        // Sort
        this.searchResultDataSource.sort = this.sorts.toArray()[4];
        const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
        this.searchResultDataSource.sort.active = defaultSort.active;
        this.searchResultDataSource.sort.direction = defaultSort.direction;
        this.searchResultDataSource.sort.sortChange.emit(defaultSort);
        this.searchResultDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

        // Filter
        this.searchResultDataSource.filterPredicate = (data: any, filter) => {
            const dataStr = JSON.stringify(data).toLowerCase();
            return dataStr.indexOf(filter) != -1;
        };

        // Label Update
        this.searchResultLabel = 'Search Results (' + this.results.length + ')';
    }

    setFilter(searchResultDataSource: any, filter: string) {
        searchResultDataSource.filter = filter.trim().toLocaleLowerCase();
    }

    checkValid() {
        if (this.chosenRegions.length > 0 && (this.selectedSchoolYear || this.selectedPerformancePeriod)) {
            return true;
        }

        return false;
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }

    schoolYearEvent(schoolYear: string) {
        this.selectedSchoolYear = schoolYear;
    }

    performancePeriodEvent(performancePeriod: string) {
        this.selectedPerformancePeriod = performancePeriod;
    }

    // MISC
    reset() {
        this.resetField = !this.resetField;
        //This is optional code To resetthe value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        this.chosenRegions = [];
        this.chosenCounties = [];
        this.chosenSchoolDistricts = [];
        this.chosenSchools = [];

        this.regionFilter = '';
        this.countyFilter = '';
        this.schoolDistrictFilter = '';
        this.schoolFilter = '';
        this.searchResultFilter = '';

        this.msg = {};
    }

    downloadExcel() {
        this.isExporting = true;
        this.msg = new MsgModel();

        let payload: any = this.generateExportPayload(this.currentSetting.EXPORTFILENAME);

        this.apiMsinExportsService.exportDataMonitoringReport(payload).subscribe({
            next: (res2: any) => {
                const blob = new Blob([res2], { type: 'application/xlsx' });

                let fileName = this.utilityService.fnMakeFileNameTime(this.currentSetting.EXPORTFILENAME);

                const renamedFile = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });

                const url = URL.createObjectURL(renamedFile);

                const a = document.createElement('a');
                a.href = url;
                fileName = fileName.trimLeft();

                a.download = fileName + '.xlsx';
                a.click();
                if (a && a.parentNode === document.body) {
                    document.body.removeChild(a);
                }

                URL.revokeObjectURL(url);
            },
            error: (e) => {
                this.msg = { SUCCESS: false, MSG: 'Error exporting Counts Report.' };
                this.isExporting = false;
            },
            complete: () => {
                this.isExporting = false;
            }
        });
    }

    generateExportPayload(exportName: string) {
        let payload = {
            settings: {
                headerNames: this.generateHeaderNames(),
                exportName: exportName
            },
            data: this.searchResultDataSource.data
        };

        return payload;
    }

    generateHeaderNames() {
        if (!this.table) {
            return [];
        }

        return Array.from(this.table.nativeElement.querySelectorAll('.mat-sort-header-content')).map((th) => th.textContent?.trim() ?? '');
    }
}
